import React, { useMemo, useRef, useState } from "react";
import { useGLTF, Html } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { useSpring, animated, config } from "@react-spring/three";
import { BiInfoCircle } from "react-icons/bi";
import { Globals } from "@react-spring/shared";

import Screen from "./Screen";

import clickOne from "../public/sound/click.mp3";
import clickTwo from "../public/sound/clickout.mp3";
import dropOne from "../public/sound/drop.mp3";
import angryLeader from "../public/sound/angry.mp3";

// Globals.assign({
//   frameLoop: "always",
// });

export default function GameBoy(props) {
  const meshRef = useRef();

  // ------------- Screen ------------------

  const [audioPlaying, setAudioPlaying] = useState(null);

  const eventHandler = async (event) => {
    // console.log(event.object);

    if (audioPlaying) {
      audioPlaying.pause();
    }

    const soundToPlay = open ? angryLeader : clickTwo;

    const newSound = new Audio(soundToPlay);
    setAudioPlaying(newSound);
    await newSound.play();

    setOpen(!open);
  };

  const [open, setOpen] = useState(false);

  const { rotation } = useSpring({
    rotation: open ? [1.45, 0, 0] : [-0.5, 0, 0],
  });

  // ------------- card ------------------
  const audio = new Audio(clickOne);

  const eventPos = async (event) => {
    // console.log(event.object);
    const audio = new Audio(clickTwo);

    if (!audio.paused) audio.pause();
    if (inCard) {
      audio.src = dropOne;
      await audio.play();
    } else {
      audio.src = dropOne;
      await audio.play();
    }

    setinCard(!inCard);
  };

  const [inCard, setinCard] = useState(false);

  const { position } = useSpring({
    position: inCard ? [0, 0, -0.3] : [0, 0, 0.19],
  });

  // ------------- game boy ------------------

  const eventamedo = async (event) => {
    // console.log(event.object);
    const audio = new Audio(clickTwo);

    if (!audio.paused) audio.pause();
    if (Flip) {
      audio.src = await audio.play();
    } else {
      audio.src = await audio.play();
    }

    setFlip(!Flip);
  };

  const [Flip, setFlip] = useState(false);

  const { groupRotation } = useSpring({
    groupRotation: Flip ? [-1.2, 0, 0] : [0, 0, 0],
  });

  const { nodes, materials } = useGLTF("/Gameboy.glb");

  const iconFlip = useRef();

  return (
    <group {...props} dispose={null}>
      <animated.group
        {...props}
        dispose={null}
        position={[0, 0, 0]}
        rotation={groupRotation}
      >
        {/* BODY */}

        <group
          position={[0, -0.26, 0.85]}
          rotation={[1.568, 0, 0]}
          scale={0.01}
          onClick={eventPos}
          ref={iconFlip}
          onDoubleClick={(event) => {
            event.stopPropagation;
          }}
        >
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.gameboy_autosave_1.geometry}
            material={materials.GameBoy}
            ref={iconFlip}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.gameboy_autosave_1_1.geometry}
            material={materials["potted_plant_01_leaves.008"]}
            ref={iconFlip}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.gameboy_autosave_1_2.geometry}
            material={materials["potted_plant_01_leaves.006"]}
            ref={iconFlip}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.gameboy_autosave_1_3.geometry}
            material={materials["potted_plant_01_leaves.020"]}
            ref={iconFlip}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.gameboy_autosave_1_4.geometry}
            material={materials["potted_plant_01_leaves.021"]}
            ref={iconFlip}
          />
        </group>

        {/* CARD */}
        <animated.group
          ref={meshRef}
          position={position}
          onContextMenu={(event) => event.stopPropagation()}
          onClick={eventPos}
          onPointerEnter={() => {
            document.body.style.cursor = "pointer";
          }}
          onPointerLeave={() => {
            document.body.style.cursor = "default";
          }}
        >
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Card.geometry}
            material={materials.Card}
            position={[0, -0.3, 1.5]}
            rotation={[Math.PI / 2, 0, 0]}
            scale={0.01}
            ref={iconFlip}
          />
        </animated.group>

        {/* end 1.45 start -0.5 */}

        <animated.group
          ref={meshRef}
          rotation={rotation}
          onContextMenu={eventHandler}
          onPointerEnter={() => {
            document.body.style.cursor = "pointer";
          }}
          onPointerLeave={() => {
            document.body.style.cursor = "default";
          }}
        >
          {/* SCREEN */}

          <Screen />

          <group position={[0, 0, 0]} rotation={[-0.231, 0, 0]} scale={0.01}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.gameboy_autosave_1003.geometry}
              material={materials.GameBoy}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.gameboy_autosave_1003_1.geometry}
              material={materials["potted_plant_01_leaves.007"]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.gameboy_autosave_1003_2.geometry}
              material={materials.potted_plant_01_leaves}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.gameboy_autosave_1003_3.geometry}
              material={materials["potted_plant_01_leaves.001"]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.gameboy_autosave_1003_4.geometry}
              material={materials["potted_plant_01_leaves.004"]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.gameboy_autosave_1003_5.geometry}
              material={materials["potted_plant_01_leaves.010"]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.gameboy_autosave_1003_6.geometry}
              material={materials["potted_plant_01_leaves.003"]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.gameboy_autosave_1003_7.geometry}
              material={materials["potted_plant_01_leaves.022"]}
            />
          </group>
        </animated.group>
      </animated.group>

      <Html
        position={[-0.9, -0.5, 1.8]}
        wrapperClass="flip"
        center
        distanceFactor={8}
      >
        <div onClick={eventamedo} occlude={iconFlip}>
          <BiInfoCircle />
        </div>
      </Html>
    </group>
  );
}

useGLTF.preload("/Gameboy.glb");
